import { Mass, Masse } from "./Masse";
import { Auftrag } from "./Auftrag";
import { WebserviceEnvironment } from "./environment";
import { Preis } from "./Preis";
/*
export type Preisanfrage = {
    plzLad : string | null;
    plzElad : string | null;
    istFahrtuechtig : boolean;
//    sendungszeilen : Sendungszeilen;
    masse : Masse | null;
    warenwert : string | null;
}
*/
export type PreisanfrageRueckgabe = {
    fehler : string | null;
    preis : Preis;
}

export const holePreisHttp = async (auftrag : Auftrag, webserviceEnvironment : WebserviceEnvironment) => {
/*    const preisanfrage : Preisanfrage = {
      plzLad : auftrag.lad.plz,
      plzElad : auftrag.elad.plz,
      masse : auftrag.sendung?.masse ?? null,
      warenwert : auftrag.sendung?.warenwert ?? null,
      istFahrtuechtig : auftrag.istFahrtuechtig,
    }
*/
    //console.log(webserviceEnvironment);
    const data = await (await fetch(webserviceEnvironment.PreisBerechnen.url, {method: 'POST', body: JSON.stringify(auftrag)})).json();
    const res : PreisanfrageRueckgabe = await webserviceEnvironment.PreisBerechnen.fnData(data);
    //setAuftrag({...auftrag, letzterPreis: res.preis})

    return res;
      //return false;
  }

  export const holePreisComponent = async (auftrag: Auftrag, webserviceEnvironment : WebserviceEnvironment) : Promise<Auftrag> => {
    const rueckgabe = await holePreisHttp(auftrag, webserviceEnvironment);
    let ret: string | null = null;
    if (rueckgabe.fehler != null) {
        throw rueckgabe.fehler;
    } else if(rueckgabe.preis == null || (rueckgabe.preis?.gesamt?.wert ?? 0) <= 0){
        throw "Fehler bei der Rückgabe des Preises";
    } else {
      return{...auftrag, letzterPreis: rueckgabe.preis};
    }
  }